export default __webpack_public_path__ + "static/media/carousel2.76367382.png";